export default {
  //产品banner
  businessList: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/business/list.vue'));
    }, '/modules/business/list');
  }
}



// WEBPACK FOOTER //
// ./src/router/modules/business.js